(() => {
  'use strict';
  const scopes = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motionAllowed = () => !reduced.matches && document.body.dataset.motion !== 'off' && !window.Shopify?.designMode;
  function mount(root = document) {
    for (const [element, dispose] of scopes) {
      if (!element.isConnected) { dispose(); scopes.delete(element); }
    }
    const elements = [...(root.matches?.('[data-ef-hero],[data-ef-chart],[data-ef-reviews]') ? [root] : []), ...root.querySelectorAll('[data-ef-hero],[data-ef-chart],[data-ef-reviews]')];
    for (const element of elements) {
      if (scopes.has(element)) continue;
      const controller = new AbortController();
      const cleanup = [];
      const on = (target, name, callback, options = {}) => target?.addEventListener(name, callback, { ...options, signal: controller.signal });
      scopes.set(element, () => { controller.abort(); cleanup.forEach(fn => fn()); });
      if (element.matches('[data-ef-hero]')) {
        let visible = true;
        const sync = () => { element.dataset.visible = String(visible && !document.hidden && motionAllowed()); };
        const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); });
        observer.observe(element);
        cleanup.push(() => observer.disconnect());
        on(document, 'visibilitychange', sync);
        on(document, 'neuro:motion', sync);
        on(reduced, 'change', sync);
        sync();
      }
      if (element.matches('[data-ef-chart]')) {
        const observer = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting) { element.dataset.inView = String(motionAllowed()); observer.disconnect(); }
        }, { threshold: .35 });
        observer.observe(element);
        cleanup.push(() => observer.disconnect());
      }
      if (element.matches('[data-ef-reviews]')) {
        const track = element.querySelector('[data-ef-track]');
        const previous = element.querySelector('[data-ef-prev]');
        const next = element.querySelector('[data-ef-next]');
        const status = element.querySelector('[data-ef-review-status]');
        const cards = [...track.querySelectorAll('.ef-review')];
        function refresh() {
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        }
        function move(direction) {
          const step = cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
          const target = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, track.scrollLeft + step * direction));
          track.scrollTo({ left: target, behavior: motionAllowed() ? 'smooth' : 'instant' });
          status.textContent = `Opinión ${Math.min(cards.length, Math.round(target / step) + 1)} de ${cards.length}`;
        }
        on(previous, 'click', () => move(-1));
        on(next, 'click', () => move(1));
        on(track, 'scroll', refresh, { passive: true });
        on(track, 'keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
        });
        on(element, 'shopify:block:select', event => {
          const card = event.target.closest('.ef-review');
          if (card && cards[0]) track.scrollTo({ left: card.offsetLeft - cards[0].offsetLeft, behavior: 'instant' });
        });
        const resize = new ResizeObserver(refresh);
        resize.observe(track);
        cleanup.push(() => resize.disconnect());
        refresh();
      }
    }
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('.ef-dropdown[open],.ef-mobile-menu[open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a,button')) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.ef-dropdown[open],.ef-mobile-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary')?.focus(); });
  });
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [element, dispose] of scopes) if (event.target.contains(element)) { dispose(); scopes.delete(element); }
  });
  window.addEventListener('pagehide', () => { for (const dispose of scopes.values()) dispose(); scopes.clear(); });
  window.addEventListener('pageshow', event => { if (event.persisted) mount(); });
  mount();
})();
